import type { FaireProductEntity } from "../../entity_types/product";

export const p_fmf4b5n7fu: FaireProductEntity = {
  token: "p_fmf4b5n7fu",
  type: "product",
  name: "Purifying Shampoo",
  brandToken: "b_82b151a0",
  brandName: "BYRD Hairdo Products",
  imageUrl:
    "https://cdn.faire.com/fastly/3430c0a8df086efa945c31918ea106d125fe466b6c884644f519ed6f00f32297.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/642c6da648d1f8dc37ae75b853821d90de68da917de803b46d50d4df78fecec7.png",
    "https://cdn.faire.com/fastly/5227c5af466017bbca1ca7abd3af7ed21c806a702391190feeca3f774ed6751f.jpeg",
    "https://cdn.faire.com/fastly/bfd45aa7498547c63b2aca439dfa9c6c0e1bb8fa1cc6cb16e289029e3cc21f32.jpeg",
  ],
  priceDollars: 10,
  description:
    "Purifying shampoo is a gentle, sulfate-free moisturizing daily cleanser with a patented blend of sea kelp, green tea, vegetable-derived glycerin & aloe vera extracts that help regulate moisture & protects against UV & other environmental damage.\n\nSea salt gives hair a beachy texture & added volume, while red algae, kelp & vitamin B5 prevent breakage.\n\nSize: 16 oz.\n\nMade in California.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:42.951Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
